/*
  Tema dos gráficos do back-office.

  Fica num arquivo só porque as cores NÃO são escolha de gosto: foram
  validadas por script contra a superfície branca dos cartões, nas quatro
  checagens que se pode medir — faixa de luminosidade, piso de croma,
  separação sob daltonismo (protanopia/deuteranopia) e contraste.

  Resultado da validação (paleta de referência, modo claro, fundo #ffffff):

    azul   #2a78d6  +  laranja #eb6834   ->  ΔE 24,7 sob daltonismo
                                             ΔE 33,6 em visão normal
                                             contraste >= 3:1   PASSA
    verde  #008300  (série única)        ->  contraste >= 3:1   PASSA

  O verde-água #1baf7a, mais óbvio para dinheiro, fica em 2,8:1 — abaixo do
  mínimo — e exigiria rótulo em todo ponto. Por isso não está aqui.

  Trocar qualquer hex sem rodar a validação de novo quebra a garantia.
*/

export const SERIES = {
  primaria: "#2a78d6",
  secundaria: "#eb6834",
  dinheiro: "#008300",
};

export const GRID = "#eceef2";
export const TEXTO_EIXO = "#8a8f9e";

/*
  Opções comuns a todos os gráficos. O que está aqui são decisões de leitura,
  não preferências:

  - grade só horizontal e tracejada: ajuda a ler valor sem competir com o dado;
  - sem barra de ferramentas e sem zoom: são painéis de leitura, não editores;
  - rótulo em todo ponto desligado — número em cima de cada marca polui o
    desenho e some na primeira série densa.
*/
export const baseChartOptions = (categorias, extras = {}) => ({
  chart: {
    toolbar: { show: false },
    zoom: { enabled: false },
    fontFamily: "inherit",
    animations: { enabled: true, easing: "easeout", speed: 420 },
    ...extras.chart,
  },
  grid: {
    borderColor: GRID,
    strokeDashArray: 4,
    xaxis: { lines: { show: false } },
    padding: { left: 4, right: 8, top: 0, bottom: 0 },
    ...extras.grid,
  },
  xaxis: {
    type: "category",
    categories: categorias,
    axisBorder: { show: false },
    axisTicks: { show: false },
    labels: {
      style: { colors: TEXTO_EIXO, fontSize: "11px" },
      hideOverlappingLabels: true,
      rotate: 0,
    },
    ...extras.xaxis,
  },
  yaxis: {
    labels: { style: { colors: TEXTO_EIXO, fontSize: "11px" } },
    ...extras.yaxis,
  },
  dataLabels: { enabled: false },
  tooltip: {
    shared: true,
    intersect: false,
    style: { fontSize: "12px", fontFamily: "inherit" },
    ...extras.tooltip,
  },
  legend: { show: false },
});

/*
  Barras: canto arredondado só na ponta do dado, ancorado na linha de base. A
  barra continua começando no zero — arredondar os dois lados faria a origem
  parecer flutuar, que é a forma mais silenciosa de mentir num gráfico de
  barras.
*/
/*
  Rótulo com o valor em cima de cada barra.

  A recomendação geral de visualização é rotular SELETIVAMENTE — número em
  todo ponto polui e some numa série densa. Aqui é decisão explícita do
  produto: são painéis de conferência, onde a pessoa quer o valor exato sem
  passar o mouse.

  Para manter legível: fonte pequena, cor de texto (nunca a cor da série, que
  faria o número competir com a barra) e sem fundo. `offsetY` negativo põe o
  número ACIMA da barra — dentro dela, barras baixas escondem o próprio
  rótulo.
*/
export const barDataLabels = (formatter) => ({
  enabled: true,
  offsetY: -18,
  style: {
    fontSize: "10px",
    fontWeight: 600,
    fontFamily: "inherit",
    colors: ["#475569"],
  },
  background: { enabled: false },
  formatter,
});

export const barPlotOptions = (horizontal = false) => ({
  bar: {
    horizontal,
    columnWidth: "46%",
    barHeight: "62%",
    borderRadius: 4,
    borderRadiusApplication: "end",
    dataLabels: { position: "top" },
  },
});
